var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGr5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35 15.75V10.5H29.75V7H35C35.9625 7 36.7868 7.343 37.4728 8.029C38.1587 8.715 38.5012 9.53867 38.5 10.5V15.75H35ZM3.5 15.75V10.5C3.5 9.5375 3.843 8.71383 4.529 8.029C5.215 7.34417 6.03867 7.00117 7 7H12.25V10.5H7V15.75H3.5ZM29.75 35V31.5H35V26.25H38.5V31.5C38.5 32.4625 38.1576 33.2868 37.4728 33.9727C36.7879 34.6588 35.9637 35.0012 35 35H29.75ZM7 35C6.0375 35 5.21383 34.6576 4.529 33.9727C3.84417 33.2879 3.50117 32.4637 3.5 31.5V26.25H7V31.5H12.25V35H7ZM10.5 28V14H31.5V28H10.5Z",
    fill: "url(#paint0_linear_1681_4180)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1681_4180",
    x1: 3.5,
    y1: 3.5,
    x2: 32.0525,
    y2: 42.5916,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2AABE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D6EB5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGr5);
export default __webpack_public_path__ + "static/media/Gr5.45a00dea6a6e032c77a803e4c4c673be.svg";
export { ForwardRef as ReactComponent };